"use strict";
// Template version: 1.2.5
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require("path");

let isNode = typeof window == "undefined";

const hostsMap = {
    "localhost": "https://stage.api.jnsseguros.com.br/tomador/",
    "stage.portaltomador.jnsseguros.com.br": "https://stage.api.jnsseguros.com.br/tomador/",
    "portaltomador.jnsseguros.com.br": "https://api.jnsseguros.com.br/tomador/"
};

let versoes = ["v1", "v2"];

let apiUrl = !isNode ?
    hostsMap[window.location.hostname] !== undefined ?
    hostsMap[window.location.hostname] :
    hostsMap["localhost"] :
    false;

module.exports = {
    versoes,
    apiUrl,
    enableAxiosInterceptorLoadingIndicator: true,
    dev: {
        // Paths
        assetsSubDirectory: "static",
        assetsPublicPath: "/",
        proxyTable: {},
        // Various Dev Server settings
        host: "0.0.0.0", // can be overwritten by process.env.HOST
        port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
        autoOpenBrowser: false,
        errorOverlay: true,
        notifyOnErrors: true,
        poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

        // Use Eslint Loader?
        // If true, your code will be linted during bundling and
        // linting errors and warnings will be shown in the console.
        useEslint: true,
        // If true, eslint errors and warnings will also be shown in the error overlay
        // in the browser.
        showEslintErrorsInOverlay: false,

        /**
         * Source Maps
         */

        // https://webpack.js.org/configuration/devtool/#development
        devtool: "eval-source-map",

        // If you have problems debugging vue-files in devtools,
        // set this to false - it *may* help
        // https://vue-loader.vuejs.org/en/options.html#cachebusting
        cacheBusting: false,

        // CSS Sourceeemaps off by default because relative paths are "buggy"
        // with this option, according to the CSS-Loader README
        // (https://github.com/webpack/css-loader#sourcemaps)
        // In our experience, they generally work as expected,
        // just be aware of this issue when enabling this option.
        cssSourceMap: false
    },

    build: {
        apiUrl: "http://192.168.1.64/api",

        // Template for index.html
        index: path.resolve(__dirname, "../dist/public/index.html"),

        // Paths
        assetsRoot: path.resolve(__dirname, "../dist/public"),
        assetsSubDirectory: "static",
        assetsPublicPath: "./",

        /**
         * Source Maps
         */

        productionSourceMap: true,
        // https://webpack.js.org/configuration/devtool/#production
        devtool: "#source-map",

        // Gzip off by default as many popular static hosts such as
        // Surge or Netlify already gzip all static assets for you.
        // Before setting to `true`, make sure to:
        // npm install --save-dev compression-webpack-plugin
        productionGzip: false,
        productionGzipExtensions: ["js", "css"],

        // Run the build command with an extra argument to
        // View the bundle analyzer report after build finishes:
        // `npm run build --report`
        // Set to `true` or `false` to always turn it on or off
        bundleAnalyzerReport: process.env.npm_config_report
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 0